export const NS = 'u3120';
